import GroupsFilter from "./GroupsFilter";

interface Props {
  placeholder: string;
  value: string[];
  onChange: (value: string[]) => void;
}

// FlashpackChannelFilter is a specialized GroupsFilter that only shows RELEASE groups (flashpack channels)
const FlashpackChannelFilter = ({ placeholder, value, onChange }: Props) => {
  return (
    <GroupsFilter placeholder={placeholder} value={value} onChange={onChange} groupType="RELEASE" />
  );
};

export default FlashpackChannelFilter;
